import { IRoadmap } from "@/shared/types/roadmap";
import React, { FC, useEffect, useState } from "react";
import styled from "styled-components";

const RouteNames: FC<{
    routes: IRoadmap[],
    selectedRouteNames: string[],
    setSelectedRouteNames: (r: string) => void,
    isTram?: boolean,
}> = ({
    routes,
    selectedRouteNames,
    setSelectedRouteNames,
    isTram,
}) => {
        const [routeNames, setNames] = useState<string[]>()

        useEffect(() => {
            const uniq = new Set();
            if (routes) {
                uniq.add('Все');
                routes.forEach(route => uniq.add(route.route_name));
                //@ts-ignore
                setNames([...uniq]);
            }

        }, [routes])

        function selectRoute(route: string) {
            //@ts-ignore
            setSelectedRouteNames(route)
            const findedRoute = routes.find(r => r.route_name === route);
        }

        return (
            <ContainerRouteNames>
                {routeNames && routeNames.map(route => (
                    <RouteName
                        key={route}
                        onClick={() => selectRoute(route)}
                        selected={selectedRouteNames.includes(route)}
                        isTram={isTram}
                    >
                        {route}
                    </RouteName>
                ))}
            </ContainerRouteNames>
        );
    }

export default RouteNames;

const ContainerRouteNames = styled.div`
    marging: 30px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap; // Разрешает перенос элементов на новую строку
    gap: 8px;
    `

const RouteName = styled.div<{ selected: boolean, isTram?: boolean }>`
    width: 55px;
    font-size: 15px;
    background-color: ${({ selected, isTram }) => (selected ?
        !isTram ? "#1E9D5F" : "#FF4D4D"
        :
        !isTram ? "#24CD73" : "#b858586c")};
    color: white;
    padding: 5px 12px;
    border-radius: 15px;
    margin: 0 10px 0 0;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: ${({ selected, isTram }) => (
        !isTram ? "#24CD73" : "#FF4D4D")}
    }
`;